import React, { useEffect, useState } from "react";
import { Row, Col, Spin, message ,Button} from "antd";
import ProductCard from "../../Components/ProductCard";
import ProductFilterList from "../../Components/ProductFilter";
import SummaryApi from "../../common/index";
//import '../../Styles/Home.css';
import axios from "axios";
import CategoryList from "../../Components/CategoryList";
import BannerProduct from "../../Components/BannerProducts";

const Home = () => {
  const [products, setProducts] = useState([]);          // All products
  const [filteredProducts, setFilteredProducts] = useState([]); // Filtered products
  const [categories, setCategories] = useState([]);      // Categories
  const [filters, setFilters] = useState({              // Filter criteria
    category: "",
    price: "",
    stock: "",
    search: "",
  });
  const [loading, setLoading] = useState(true);
   const [totalPages, setTotalPages] = useState(1);
const [currentPage, setCurrentPage] = useState(1);
            // Current page
  const limit = 8;

  // Fetch products
  const fetchProducts = async (page = 1) => {
  try {
    const offset = (page - 1) * limit;

    const url = `${SummaryApi.fetchProduct.url}?limit=${limit}&offset=${offset}`;

    const res = await axios.get(url);

    if (res.data.success) {
      setProducts(res.data.products);
      setFilteredProducts(res.data.products);
      setCurrentPage(page);
       setTotalPages(res.data.totalPages);
    } else {
      message.error("Failed to fetch products");
    }
  } catch (err) {
    console.error("Fetch Products Error:", err);
    message.error("Server error while fetching products");
  }
};

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const res = await axios(SummaryApi.getCategories.url);
      setCategories(res.data.categories || []);
    } catch (err) {
      console.error("Error fetching categories:", err);
      message.error("Failed to load categories");
    }
  };

  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    await fetchProducts(1);
    await fetchCategories();
    setLoading(false);
  };
  fetchData();
}, []);
const handleNext = () => {
  setCurrentPage((prev) => {
    const newPage = prev + 1;
    fetchProducts(newPage);
    return newPage;
  });
};

const handlePrev = () => {
  setCurrentPage((prev) => {
    if (prev === 1) return 1;
    const newPage = prev - 1;
    fetchProducts(newPage);
    return newPage;
  });
};
  useEffect(() => {
    let temp = [...products];
    if (filters.category) {
      temp = temp.filter((p) => p.category === filters.category);
    }

    // Price filter
    if (filters.price) {
      const [min, max] = filters.price.split("-").map(Number);
      temp = temp.filter((p) => p.selling_price >= min && p.selling_price <= max);
    }

    // Stock filter
    if (filters.stock === "in") temp = temp.filter((p) => p.stock > 0);
    if (filters.stock === "low") temp = temp.filter((p) => p.stock > 0 && p.stock < 10);

    // Search filter
    if (filters.search) {
      temp = temp.filter((p) =>
        p.name.toLowerCase().includes(filters.search.toLowerCase())
      );
    }

    setFilteredProducts(temp);
  }, [filters, products]);

  if (loading)
    return <Spin size="large" style={{ margin: "50px auto", display: "block" }} />;

  return (
  <div style={{ padding: "20px" }}>
      <ProductFilterList filters={filters} onFilterChange={setFilters} categories={categories} />
       {currentPage === 1 && (
    <CategoryList
      categories={categories}
      onSelectCategory={(id) =>
        setFilters({ ...filters, category: id })
      }
    />
  )}

      <Row gutter={[16, 16]}  >
        {filteredProducts.length ? (
          filteredProducts.map((product) => (
            <Col key={product.id} xs={24} sm={12} md={12} lg={8} xl={6}  style={{ display: "flex", justifyContent: "center" }}>
              <ProductCard product={product} />
            </Col>
          ))
        ) : (
          <p>No products found.</p>
        )}
      </Row>

      <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: "10px" }}>
       <Button onClick={handlePrev} disabled={currentPage === 1}>Prev</Button>
<Button onClick={handleNext} disabled={currentPage === totalPages}>Next</Button>

      </div>
    </div>
  );
};

export default Home;